(ns iris.hench
  (:require
   [clojure.string :as string]
   [iris.auth.api :as auth]
   [iris.data.api :as data]

   [iris.indexeddb :as idb]

   [cljs.core.async :refer [go go-loop <! >! chan]]
   [cljs.core.async.interop :refer-macros [<p!]]))



(def ABBR_MIN_LEN 3)

(def RAIDIZABLE_EPREFIXES #{"a:" "c:" "d:" "f:" "g:" "i:" "m:" "l:"})
(def RAIDIZABLE_LETTERS (map #(get % 0) RAIDIZABLE_EPREFIXES))
(def EID_PREFIX_RE (str "[" (string/join RAIDIZABLE_LETTERS) "]:"))

(def RPREFIXES {"acc" "[ac]"
                "acl" "[al]"
                "bfp" "&"
                "cc" ":"
                "cookie" "*"
                "dfp" "~"
                "geoloc" "!"
                "ip" "^"
                "ua" "%"})

(def RPREFIX_TO_KIND (zipmap (vals RPREFIXES) (keys RPREFIXES)))

(def EPREFIXES {"acc" "m:"
                "acl" "l:"
                "bfp" "f:"
                "cc" "z:"
                "cookie" "c:"
                "dfp" "d:"
                "geoloc" "g:"
                "ip" "i:"
                "ua" "a:"})

(def R2E_PREFIXES (reduce-kv (fn [m k v] (assoc m k (get EPREFIXES v))) {} RPREFIX_TO_KIND))
(def E2R_PREFIXES (zipmap (vals R2E_PREFIXES) (keys R2E_PREFIXES)))

(def ENCRYPTABLE_RPREFIXES  #{"~" "%" "&" "^" "*" "!"})
(def EPREFIX_NO_RPREFIX #{"m:" "l:"})


(def A_RAID_RE "%[a-z0-9]{1,}\\b")
(def C_RAID_RE "\\*[a-z0-9]{1,}\\b(?!-)")
(def D_RAID_RE "~[a-z0-9]{1,}\\b(?!-)")
(def F_RAID_RE "&[a-z0-9]{1,}\\b(?!-)")
(def G_RAID_RE "![a-z0-9]{1,}\\b")
(def I_RAID_RE "\\^[a-z0-9]{1,}\\b(?![:.])")
(def L_RAID_RE "\\bl:[a-z0-9]{1,}\\b")
(def M_RAID_RE "\\bm:[a-z0-9]{1,}\\b")
(def RAID_RE (string/join "|" [A_RAID_RE
                               C_RAID_RE
                               D_RAID_RE
                               F_RAID_RE
                               G_RAID_RE
                               I_RAID_RE
                               L_RAID_RE
                               M_RAID_RE]))

(def my-re (re-pattern RAID_RE))


(defn raidizable? [eid]
  (when (and
         (not-empty eid)
         (contains? RAIDIZABLE_EPREFIXES (subs eid 0 2))) true))

(defn r2e-prefix [rprefix]
  (when (and (= (count rprefix) 1) (contains? (str rprefix ":") EPREFIX_NO_RPREFIX))
    (r2e-prefix (str rprefix ":")))
  (if (contains? rprefix EPREFIX_NO_RPREFIX)
    rprefix
    (get R2E_PREFIXES rprefix)))


(defn expand [abbr]
  (cond
    (empty? abbr) abbr
    (string/ends-with? abbr ":...") (str (get abbr 0) ":...")
    :else
    (go
      (let [eid (<p! (data/get-raid2eid abbr))]
        (when (empty? eid)
      ;; (throw (str "Eid abbreviation" abbr "not found in cache"))
          (println (str "Eid abbreviation " abbr " not found in cache")))
        eid))))


(defn raid-to-eid [raid]
  (cond (empty? raid) ""
        :else
        (let [rprefix (get raid 0)
              serial (subs raid 1)
              eprefix (r2e-prefix rprefix)
              abbr (str eprefix serial)]
          (go (<! (expand abbr))))))


(defn <unraidize [scopes-expr]
  (let [raids (re-seq my-re scopes-expr)]
    (go-loop [rs raids
              s scopes-expr]
      (if-not (empty? rs)
        (let [r (first rs)
              eid (<! (raid-to-eid r))
              ns (string/replace s r eid)]
          (recur (rest rs) ns))
        s))))


(defn <unraidize-report-errors [scopes-expr]
  (let [raids (re-seq my-re scopes-expr)]
    (go-loop [rs raids
              s scopes-expr
              err []]
      (if-not (empty? rs)
        (let [r (first rs)
              eid (<! (raid-to-eid r))
              ns (string/replace s r eid)]
          (recur (rest rs)
                 ns
                 (if (nil? eid) (conj err r) err)))
        {:scopes-expr s :err err}))))


(defn <validate-raids-from-scopes-expr [scopes-expr]
  (let [raids (re-seq my-re scopes-expr)]
    (go-loop [rs raids
              err []]
      (if-not (empty? rs)
        (let [r (first rs)
              eid (<! (raid-to-eid r))]
          (recur (rest rs)
                 (if (nil? eid)
                   (conj err r)
                   err)))
        err))))


(defn e2r_prefix [eprefix]
  (if (contains? EPREFIX_NO_RPREFIX eprefix)
    eprefix
    (get E2R_PREFIXES eprefix)))


(defn abbreviate [eid]
    (go
      (loop [abbr-len ABBR_MIN_LEN]
        (when (> abbr-len (count eid))
        ;; (throw (str "No available abbreviation for eid " eid))
          (println (str "No available abbreviation for eid " eid)))

        (let [candidate (subs eid 0 abbr-len)
              candidate-eid (<p! (data/get-raid2eid candidate))]
          (cond
            (empty? candidate-eid)
            (do
              (data/set-raid2eid candidate eid)
              ;; (recur abbr-len)
              candidate)
            (= candidate-eid eid)
            (do
              ;; (println "candiates same" candidate-eid eid candidate)
              candidate)
            :else
            (do
              (recur (inc abbr-len))))))))


(defn abbr-to-raid [abbr]
  (let [eprefix (subs abbr 0 2)
        serial (subs abbr 2)
        rprefix (e2r_prefix eprefix)
        raid (str rprefix serial)]
    raid))


(defn eid-to-raid [eid]
  (cond
    (empty? eid) eid
    (some #(string/starts-with? eid %) RAIDIZABLE_EPREFIXES)
    (go
      (let [a (<! (abbreviate eid))
            eprefix (subs a 0 2)
            serial (subs a 2)
            rprefix (e2r_prefix eprefix)]
        (str rprefix serial)))
    :else
    ;;  (throw "Cannot raidize eid: " eid)
    (println "Cannot raidize eid: " eid)))



;; "raidize" goes straight to firebase without checking cache/indexeddb
;; while "raidize-cached" below expects data to be in the cache/indexeddb already
;; there should be a function that does both, checks cache and if not there goes to firebase
;; there could also be one where eid-raid map is provided as argument which doesn't require async go blocks
;; (update: raidize-scopes-display defmulti does both)
;; by the way, these are specific for screens/censors because they have scopes/scope-display
;; so perhaps they shouldn't be here?

;; function that does both, checks cache and if not there goes to firebase
;; this is actually a single "eid to raid" version of "eid-to-raid-set-cache" which operates on list of eids
;; NOTE: not tested! (update: tested briefly seems to work)
(defn <get-set-raid [eid]
  (go
    (try
      ;; (let [user (<! (fb/wait-for-auth-user))]
      (when (auth/authenticated?)
        (if-let [raid (<p! (idb/get-raid eid))]
          raid
            ;; not found in indexeddb, but found in firebase
          (if-let [abbr (<p! (data/get-eid2raid eid))]
            (let [raid (abbr-to-raid abbr)]
              (idb/add-raid eid raid)
              raid)
              ;; not found in indexeddb nor firebase
            (if (raidizable? eid)
              (let [raid (<! (eid-to-raid eid))]
                (idb/add-raid eid raid)
                raid)
              (do
                ;; maybe throw here instead
                (println "raid does not exist in cache, nor firebase, nor can it be raidized")
                "non-raid!")))))
      (catch js/Error err (js/console.log err)))))


;; raidize and raidized cached are too ambigious function names, raidize-scopes-display is much clearer
(defn raidize [scopes scopes-display]
  (let [eids (filter #(when (contains? RAIDIZABLE_EPREFIXES (subs % 0 2)) true) scopes)]
    (go
      (cond (empty? eids)
            scopes-display
            :else
            (loop [eids eids
                   scopes-display scopes-display]
              (let [eid (first eids)
                    raid (<! (eid-to-raid eid))
                    new-scopes-display (string/replace scopes-display eid raid)
                    new-eids (rest eids)]
                (if (not-empty (rest eids))
                  (recur new-eids new-scopes-display)
                  new-scopes-display)))))))


;; (defn raidize-cached [scopes scopes-display]
;;   (go
;;     (let [eids (filter #(when (contains? RAIDIZABLE_EPREFIXES (subs % 0 2)) true) scopes)]
;;       (cond (empty? eids)
;;             scopes-display
;;             :else
;;             (loop [eids eids
;;                    scopes-display scopes-display]
;;               (let [eid (first eids)
;;                     raid (<p! (idb/get-raid eid))
;;                     new-scopes-display (string/replace scopes-display eid raid)
;;                     new-eids (rest eids)]
;;                 (if (not-empty new-eids)
;;                   (recur new-eids new-scopes-display)
;;                   new-scopes-display)))))))

;; same as the original raidize-cached except it calls function that will get raids from firebase if it doesn't find them in indexeddb/cache
;; since then replaced with "raidize-scopes-display" multimethod
(defn raidize-cached [scopes scopes-display]
  (go
    (let [eids (filter #(when (contains? RAIDIZABLE_EPREFIXES (subs % 0 2)) true) scopes)]
      (cond (empty? eids)
            scopes-display
            :else
            (loop [eids eids
                   scopes-display scopes-display]
              (let [eid (first eids)
                    raid
                    ;; (<p! (idb/get-raid eid))
                    (<! (<get-set-raid eid))
                    new-scopes-display (string/replace scopes-display eid raid)
                    new-eids (rest eids)]
                (if (not-empty new-eids)
                  (recur new-eids new-scopes-display)
                  new-scopes-display)))))))



(defmulti raidize-scopes-display
  (fn [scopes scopes-display & args]
    (if-let [eids-raids (:eids-raids (first args))]
      :default
      :go)))


(defmethod raidize-scopes-display :default [scopes scopes-display & args]
    (let [eids-raids (:eids-raids (first args))
          scope-eids (filter #(when (contains? RAIDIZABLE_EPREFIXES (subs % 0 2)) true) scopes)]
      (cond (empty? scope-eids)
            scopes-display
            :else
            (loop [scope-eids scope-eids
                   scopes-display scopes-display]
              (let [eid (first scope-eids)
                    raid ((keyword eid) eids-raids)
                    new-scopes-display (string/replace scopes-display eid raid)
                    new-scope-eids (rest scope-eids)]
                (if (not-empty new-scope-eids)
                  (recur new-scope-eids new-scopes-display)
                  new-scopes-display))))))

(defmethod raidize-scopes-display :go [scopes scopes-display]
  (go
    (let [scope-eids (filter #(when (contains? RAIDIZABLE_EPREFIXES (subs % 0 2)) true) scopes)]
      (cond (empty? scope-eids)
            scopes-display
            :else
            (loop [scope-eids scope-eids
                   scopes-display scopes-display]
              (let [eid (first scope-eids)
                    raid (<! (<get-set-raid eid))
                    new-scopes-display (string/replace scopes-display eid raid)
                    new-scope-eids (rest scope-eids)]
                (if (not-empty new-scope-eids)
                  (recur new-scope-eids new-scopes-display)
                  new-scopes-display)))))))



;; delete this
;; (defn raidize-scopes-display
;;   ([scopes scopes-display]
;;    (go
;;      (let [scope-eids (filter #(when (contains? RAIDIZABLE_EPREFIXES (subs % 0 2)) true) scopes)]
;;        (cond (empty? scope-eids)
;;              scopes-display
;;              :else
;;              (loop [scope-eids scope-eids
;;                     scopes-display scopes-display]
;;                (let [eid (first scope-eids)
;;                      raid (<! (<get-set-raid eid))
;;                      new-scopes-display (string/replace scopes-display eid raid)
;;                      new-scope-eids (rest scope-eids)]
;;                  (if (not-empty new-scope-eids)
;;                    (recur new-scope-eids new-scopes-display)
;;                    new-scopes-display)))))))
;;   ([scopes scopes-display eids-raids]
;;    (go
;;      (let [scope-eids (filter #(when (contains? RAIDIZABLE_EPREFIXES (subs % 0 2)) true) scopes)]
;;        (cond (empty? scope-eids)
;;              scopes-display
;;              :else
;;              (loop [scope-eids scope-eids
;;                     scopes-display scopes-display]
;;                (let [eid (first scope-eids)
;;                     ;; raid (<p! (idb/get-raid eid))
;;                      raid ((keyword eid) eids-raids)
;;                      new-scopes-display (string/replace scopes-display eid raid)
;;                      new-scope-eids (rest scope-eids)]
;;                  (if (not-empty new-scope-eids)
;;                    (recur new-scope-eids new-scopes-display)
;;                    new-scopes-display))))))))





(defn temp-prefix
  ;; single eid
  ([eid]
   (let [eprefix (subs eid 0 2)
         rprefix (e2r_prefix eprefix)
         firstchar (subs eid 2 3)
         tprefix (str rprefix firstchar "<span class=\"dotty\"></span>")]
     tprefix))
  ;; scopes of eids
  ([scopes scopes-display]
   (let [eids (filter #(when (contains? RAIDIZABLE_EPREFIXES (subs % 0 2)) true) scopes)]
     (cond (empty? eids)
           scopes-display
           :else
           (loop [eids eids
                  scopes-display scopes-display]
             (let [eid (first eids)
                   eprefix (subs eid 0 2)
                   rprefix (e2r_prefix eprefix)
                   firstchar (subs eid 2 3)
                   tprefix (str rprefix firstchar "<span class=\"dotty\"></span>")
                   new-scopes-display (string/replace scopes-display eid tprefix)
                   new-eids (rest eids)]
               (if (not-empty new-eids)
                 (recur new-eids new-scopes-display)
                 new-scopes-display)))))))


;; (defn temp-prefix-2 [eid]
;;   (let [eprefix (subs eid 0 2)
;;         rprefix (e2r_prefix eprefix)
;;         firstchar (subs eid 2 3)
;;         tprefix (str rprefix firstchar "<span class=\"dotty\"></span>")]
;;     tprefix))


;; the following are used from events (list success)

(defn get-distinct-scopes [result-data]
  (loop [v []
         d result-data]
    (if-not (empty? d)
      (recur (into v (:scopes (first d))) (rest d))
      (filter raidizable? (distinct v)))))


;; this function was actually NOT setting cache but instead having listener do it (which was doing it every time whether data was already in indexed db or not)
;; also it was sub optiomal, calling get-raid function multiple times
;; (defn eid-to-raid-set-cache [eids c]
;;   (go
;;     (try
;;       (let [uid (<p! (fb/auth-promise))]
;;         (loop [eids eids]
;;           (let [eid (first eids)]
;;             ;; first check if raid is in indexeddb
;;             (if (and
;;                  (empty? (<p! (idb/get-raid eid)))
;;                  (raidizable? eid))
;;               ;; raid is not in indexeddb, try to get it from firebase
;;               (let [abbr (<p! (fb/get-eid2raid eid))]
;;                 (if (empty? abbr)
;;                   ;; it's not in fb either, create one, return it and put it on channel
;;                   (go
;;                     (let [raid (<! (eid-to-raid eid))]
;;                       (>! c {:eid eid :raid raid})))
;;                   ;; it's already in fb, just return and put it on channel
;;                   (go (>! c {:eid eid :raid (abbr-to-raid abbr)})))) ;; try put! here as well
;;               ;; raid is in indexed db, put it on channel NOTE: (idb/get-raid eid) is being run twice in this function!
;;               (go (>! c {:eid eid :raid (<p! (idb/get-raid eid))})))
;;             (when (not-empty (rest eids))
;;               (recur (rest eids))))))
;;       (catch js/Error err (js/console.log err)))))


;; new version - this could also be done with a promise without channel
(defn eid-to-raid-set-cache [eids c]
  (go
    (try
      ;; (let [user (<! (fb/wait-for-auth-user))]
      (when (auth/authenticated?)
        (loop [eids eids
               eids-raids {}]
          (if (empty? eids)
            ;; empty so put the results on channel to deliver to listener
            (>! c eids-raids)
            ;; not empty so raidize first eid on the list of remaining eids and recur
            (let [eid (first eids)]
            ;; found in indexeddb
              (if-let [raid (<p! (idb/get-raid eid))]
                (recur (rest eids) (assoc eids-raids (keyword eid) raid))
              ;; not found in indexeddb, but found in firebase
                (if-let [abbr (<p! (data/get-eid2raid eid))]
                  (let [raid (abbr-to-raid abbr)]
                    (idb/add-raid eid raid)
                    (recur (rest eids) (assoc eids-raids (keyword eid) raid)))
                ;; not found in indexeddb nor firebase
                  (if (raidizable? eid)
                    (let [raid (<! (eid-to-raid eid))]
                      (idb/add-raid eid raid)
                      (recur (rest eids) (assoc eids-raids (keyword eid) raid)))
                    (recur (rest eids) eids-raids))))))))
      (catch js/Error err (js/console.log err)))))


(defn author-eid-raid [d r k]
  ;; (if-let [raid (get-in d [:author :raid k])]
  (if-let [raid (k r)]
    raid
    (if-let [eid (get-in d [:author :eid k])]
      (temp-prefix eid)
      "")))


(defn author-eid-raid-2 [raid eid]
  (or raid (temp-prefix eid) ""))


(defn eid-len-raid [eid num-chars]
  (if (raidizable? eid)
    (let [eprefix (subs eid 0 2)
          serial (subs eid 2 (+ 2 num-chars))
          rprefix (e2r_prefix eprefix)
          raid (str rprefix serial)]
      raid)
    eid))

;; works - returns vector of raids (raids-len/sheids)
;; (defn eids-len-raids [eids num-chars]
;;   (loop [_eids (filter raidizable? eids)
;;          raids []]
;;     (if-not (empty? _eids)
;;       (let [eid (first _eids)
;;             raid (eid-len-raid eid num-chars)]
;;         (recur (rest _eids) (conj raids raid)))
;;       raids)))


(defn eids-len-raids [eids num-chars]
  (loop [_eids (filter raidizable? eids)
         eids-raids {}]
    (if-not (empty? _eids)
      (let [eid (first _eids)
            raid (eid-len-raid eid num-chars)]
        (recur (rest _eids) (assoc eids-raids (keyword eid) raid)))
      eids-raids)))

;; (assoc eids-raids (keyword eid) raid)